import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/portfolio";
import { useReveal } from "@/hooks/useReveal";

export default function Testimonials() {
  const { ref, visible } = useReveal();
  return (
    <section id="testimonials" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10" ref={ref}>
        <div className={`max-w-2xl mb-12 fade-in-up ${visible ? "in" : ""}`}>
          <div className="section-label mb-4">Testimonials</div>
          <h2 className="heading-hero text-4xl md:text-5xl lg:text-6xl">
            What clients<br/>
            <span className="text-[#FF3B30]">have to say.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              className={`glass-card rounded-3xl p-8 relative overflow-hidden fade-in-up ${visible ? "in" : ""}`}
              style={{ transitionDelay: `${i * 100}ms` }}
              data-testid={`testimonial-${i}`}
            >
              <Quote size={72} className="absolute -top-3 -right-2 text-white/[0.04]" />
              <div className="flex items-center gap-1 mb-4 text-[#FF3B30]">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <p className="text-white/80 leading-relaxed text-base mb-6 relative z-10">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full grid place-items-center bg-gradient-to-br from-[#FF3B30] to-[#7a1a12] text-white font-display font-bold text-sm shadow-lg shadow-red-500/20">
                  {t.name.split(' ').map(w => w[0]).slice(0,2).join('')}
                </div>
                <div>
                  <p className="font-display font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-white/50">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
